document.addEventListener('DOMContentLoaded', function() {
    // Add to Cart click listener for non-form buttons
    document.body.addEventListener('click', function(e) {
      if (e.target && e.target.matches('a[onclick*="Shopify.addItem"]')) {
        var btn = e.target;
        var quantity = parseInt(btn.dataset.quantity, 10) || 1;
        var price = (btn.dataset.price / 100).toFixed(2);
        
        window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        'event': 'add_to_cart',
        'event_by': 'digitxl_NKRCDJVN',
        'ecommerce': {
          'value': price * quantity,
          'items': [{
          'item_name': btn.dataset.productTitle,
          'item_id': btn.dataset.variantSku || btn.dataset.variantId,
          'price': price,
          'item_brand': btn.dataset.vendor,
          'item_category': btn.dataset.productType,
          'item_variant': btn.dataset.variantTitle,
          'quantity': quantity
          }]
        }
      });
      console.log('Add to Cart event:', {
        'event': 'add_to_cart',
        'event_by': 'digitxl_NKRCDJVN',
        'ecommerce': {
          'value': price * quantity,
          'items': [{
          'item_name': btn.dataset.productTitle,
          'item_id': btn.dataset.variantSku || btn.dataset.variantId,
          'price': price,
          'item_brand': btn.dataset.vendor,
          'item_category': btn.dataset.productType,
          'item_variant': btn.dataset.variantTitle,
          'quantity': quantity
          }]
        }
      });
      }
    });
  });
  